export default __webpack_public_path__ + "static/media/(26).a601efdf.JPG";